/**
 * @template {Function} T
 * @param {T} callback
 * @param {number} [delay]
 * @returns {T}
 */
const debounce = (callback, delay = 150) => {
    let timeoutId;
    // @ts-ignore
    return function () {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => {
            callback.apply(this, arguments);
        }, delay);
    };
};

export default debounce;
